import { render, staticRenderFns } from "./ReceiptPaymentDefaultDetailed.vue?vue&type=template&id=3fa2e608"
import script from "./ReceiptPaymentDefaultDetailed.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentDefaultDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports